import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoginRequestDialogComponent } from '@Components/Dialog/login-request-dialog/login-request-dialog.component';
import { NotificationService } from '@Services/notification.service';
import { SeoService } from '@Services/seo.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Musei Italiani - Acquista Biglietti';

  private destroy$ = new Subject<void>();

  @ViewChild('loginRequestDialog') loginRequestDialog!: LoginRequestDialogComponent;

  constructor(
    private seoService: SeoService,
    private notificationSvc: NotificationService,
  ) {  }

  ngOnInit() {
    this.seoService.setMetaTagSEO();
    this.listenForNotification();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* istanbul ignore next */
  private listenForNotification(){
    this.notificationSvc.notification$
    .pipe(takeUntil(this.destroy$))
    .subscribe(notification => {
      if(!notification) return;

      if(notification.reason === 'login_required') this.loginRequestDialog.showModal();
    })
  }
}
